import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

import { SessionService } from '../shared';

ng.module('e360').run(loginBypassHook);

loginBypassHook.$inject = ['$transitions', 'session'];
function loginBypassHook($transitions:uir.TransitionService, session:SessionService) {
   $transitions.onBefore({to: 'login'}, redirectToDashboard, {priority: 10});

   function redirectToDashboard(transition:uir.Transition) {
      let $state = transition.router.stateService;
      if (session.isLoggedIn()) {
         return $state.target('dashboard', undefined, { location: true });
      }
   }
}
